import { useState } from "react";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";

const useNotificationTimeList = () => {

    const [times, setTimes] = useState([]);
    const [isTimeLoading, setIsTimeLoading] = useState(false);

    const getTimes = async () => {
        try {
            setIsTimeLoading(true);
            const response = await axios.get(`${BASE_URL}/notification/time-range/list`);
            const timesList = response?.data?.data;
            setTimes(timesList);
            return timesList;
        } catch (error) {
            console.error("Error fetching time list:", error);
        } finally {
            setIsTimeLoading(false);
        }
    };

    return { times, isTimeLoading, getTimes };
};

export default useNotificationTimeList;
